module.exports = __webpack_public_path__ + "static/media/reforcoEscolar.31065c23.svg";